import { render, staticRenderFns } from "./CertificateCard.vue?vue&type=template&id=b9865414&scoped=true&"
import script from "./CertificateCard.vue?vue&type=script&lang=ts&"
export * from "./CertificateCard.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateCard.vue?vue&type=style&index=0&id=b9865414&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9865414",
  null
  
)

export default component.exports